import languages from '@/data/languages'
import privacyPolicy from '@/data/privacy-policy'

const state = {
    id: 'en',
    langs: Object.keys(languages).map(l => {
        return {
            id: l,
            label: languages[l].label
        }
    })
}

const mutations = {
    setLang(state, lang) {
        state.id = lang
    }
}

const actions = {
    setLang({ commit }, lang) {
        const tracks = [ ...document.getElementById("video-demo").textTracks ]
        let targeted = tracks.find( track => track.mode === "showing" )
        if( targeted ) targeted.mode = "disabled"
        commit('setLang', lang)
        targeted = tracks.find( track => track.language === state.id )
        if( targeted ) targeted.mode = "showing"
    }
}

const getters = {
    id(state) {
        return state.id
    },
    lang(state) {
        return languages[state.id]
    },
    langs(state) {
        return state.langs
    },
    privacyPolicy(state) {
        return privacyPolicy[state.id]
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}